import { Location } from './useGetLocations';
import { getRoute } from '../../../../../crud/location.crud';

export function useYamap({
  startLocation,
  endLocation,
  setTime,
  setLength,
}: {
  startLocation: Location;
  endLocation: Location;
  setTime: (time: number) => void;
  setLength: (length: number) => void;
}) {

  const handleOrderSumm = async ({
    newStartLocation,
    newEndLocation,
  }: {
    newStartLocation?: Location;
    newEndLocation?: Location;
  } = {}) => {
    if (!startLocation?.lat || !endLocation?.lat) {
      return;
    }
    const res = await getRoute(
      `${newStartLocation?.lat || startLocation.lat},${
        newStartLocation?.lng || startLocation.lng
      }`,
      `${newEndLocation?.lat || endLocation.lat},${newEndLocation?.lng || endLocation.lng}`
    );

    const distance = res.data?.rows?.[0].elements?.[0]?.distance?.value || 0;
    const time = res.data?.rows?.[0].elements?.[0]?.duration?.value || 0;

    setTime(Math.ceil(time / 60));
    setLength(Math.ceil(distance / 1000));

    // multiRoute.model.events.add('requestsuccess', () => {
    //   const activeRoute = multiRoute.getActiveRoute();
    //   if (activeRoute) {
    //     // Расстояние в метрах
    //     const distance = activeRoute.properties.get('distance', { value: 0 });
    //     // Время в пути в секундах
    //     const time = activeRoute.properties.get('duration', { value: 0 });
    //     // @ts-ignore
    //     setTime(Math.ceil(time.value / 60));
    //     // @ts-ignore
    //     setLength(Math.ceil(distance.value / 1000));
    //   }
    // });
  };

  return { handleOrderSumm };
}
